import axios, { AxiosInstance, AxiosResponse } from "axios";
import Cookies from "js-cookie";
import { DateTime } from "luxon";

const baseURL = process.env.REACT_APP_URL_API;

const axiosInstance: AxiosInstance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
    "accept": "*/*",
  },
});

axiosInstance.interceptors.request.use((config) => {
  const cookieToken = Cookies.get("access_token");
  const lsToken =
    typeof window !== "undefined" ? localStorage.getItem("access_token") : null;
  const token = cookieToken || lsToken;

  if (token) {
    config.headers = config.headers ?? {};
    config.headers["Authorization"] = `Bearer ${token}`;
  } else if (config.headers && "Authorization" in config.headers) {
    delete (config.headers as Record<string, unknown>)["Authorization"];
  }

  return config;
});

axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error) => {
    console.error("API error:", error);
    return Promise.reject(error);
  }
);

export const getUserProfile = async (): Promise<any> => {
  try {
    const response = await axiosInstance.get("/users/current");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getFormattedTime = () => {
  return DateTime.now()
    .setZone('Asia/Ho_Chi_Minh')
    .toFormat('dd-MM-yyyy HH:mm:ss');
};